import type { Margin } from "~/v2/api/rest/account";
import type { Position } from "~/v3-poc/api/positions.schema";
import type { HeaderPortfolioTotals } from "./headerPortfolioMetrics.utils";
import {
  parseMarginAmount,
  sumPositionTotals,
} from "./headerPortfolioMetrics.utils";

export interface HeaderPortfolioMetricsControllerInput {
  positions: readonly Position[];
  margin: Margin | null | undefined;
  isAccountReady: boolean;
  isPositionsError: boolean;
}

export interface HeaderPortfolioMetricsControllerOutput {
  totals: HeaderPortfolioTotals | null;
}

export const useHeaderPortfolioMetricsController = ({
  positions,
  margin,
  isAccountReady,
  isPositionsError,
}: HeaderPortfolioMetricsControllerInput): HeaderPortfolioMetricsControllerOutput => {
  const positionTotals = sumPositionTotals(positions);
  const equity = parseMarginAmount(margin?.equity);
  const lastEquity = parseMarginAmount(margin?.last_equity);
  const accountDailyPnl =
    equity === null || lastEquity === null ? null : equity - lastEquity;

  const totals =
    isAccountReady && !isPositionsError
      ? {
          ...positionTotals,
          todaysPnl:
            positions.length === 0 && accountDailyPnl !== null
              ? accountDailyPnl
              : positionTotals.todaysPnl,
          equity,
          lastEquity,
          buyingPower: parseMarginAmount(margin?.buying_power),
        }
      : null;

  return { totals };
};
